module.exports = __webpack_public_path__ + "static/media/iveco.fb48171d.png";